import type { PortalAuthConfig } from "@dearbill/shared";
import { ContactSupportButton } from "../components/ContactSupportButton";

/**
 * The partner portal's binding of the shared auth screens: the
 * `db.partner.session` storage key, the `/api/partner` mount, the partner copy
 * and the "Contact us" trigger in the login footer. No `authExtra`: partner
 * login carries only the email and password. No `branding`: the partner portal
 * is DearBill's own.
 */
export const PARTNER_AUTH_CONFIG: PortalAuthConfig = {
  storageKey: "db.partner.session",
  apiPrefix: "/api/partner",
  copy: {
    loginTitle: "Partner sign in",
    loginSubtitle: "Sign in to manage your organizations.",
    setPasswordSubtitle: "Choose a password to finish setting up your partner account.",
  },
  loginHelp: (
    <span>
      Need help? <ContactSupportButton size="md" className="text-midnight min-h-11 p-0 text-base" />
    </span>
  ),
};
